import {getUserAuth} from 'common/src/modules/auth/auth.service';
import axios, {AxiosError, AxiosResponse} from 'axios';
import {ApiError} from '../errorHandling/errorHandling.types';
import constructApiService from './apiConstruct';
import {ApiOptions, ApiResponse} from './apiTypes';
import getApiBasePath from './utils/getApiBasePath';

function handleResponse<T>(response: AxiosResponse<ApiResponse<T>>) {
  return response.data.Payload;
}

function handleError(error: AxiosError<ApiResponse<unknown>>): ApiError {
  return {
    ...error,
    message: error.response?.data?.Message || error.message,
    status: error.response?.status,
    isCanceled: axios.isCancel(error),
  } as ApiError;
}

function createApiUrl({endpoint: endpoint, options}: {endpoint: string; options: ApiOptions}) {
  const url = new URL(endpoint, getApiBasePath());
  const includeClientId = options.includeClientId ?? true;

  if (includeClientId) {
    const {clientId} = getUserAuth();
    url.searchParams.append('clientId', clientId.toString());
  }

  return url.toString();
}

const apiService = constructApiService({
  handleResponse,
  createApiUrl,
  handleError,
  useFormDataAsDefault: true,
});

export default apiService;
